/* website-builder: quantity-break offer box (replaces bundle apps such as Kaching Bundles).
   Prices follow the store's product data; the discounts themselves are native Shopify
   automatic discounts created when the clone is published. */
(() => {
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function money(cents, format) {
    const f = format || '{{amount}}';
    const m = f.match(/\{\{\s*(\w+)\s*\}\}/);
    const kind = m ? m[1] : 'amount';
    const dec = /no_decimals/.test(kind) ? 0 : 2;
    const [int, frac] = (cents / 100).toFixed(dec).split('.');
    const sep = /space/.test(kind) ? ' ' : /comma/.test(kind) ? '.' : /apostrophe/.test(kind) ? "'" : ',';
    const point = /comma|space/.test(kind) ? ',' : '.';
    const i = int.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    return f.replace(/\{\{\s*\w+\s*\}\}/, frac ? i + point + frac : i);
  }

  // same rounding as the build and the discounts: …9 for whole-number currencies, x.99 otherwise
  function charm(cents, decimals) {
    if (decimals === 0) {
      const whole = Math.floor(cents / 100 + 1e-6);
      if (whole < 10) return whole * 100;
      return (whole % 10 === 9 ? whole : Math.floor(whole / 10) * 10 - 1) * 100;
    }
    const whole = Math.round(cents / 100);
    return whole < 1 ? Math.round(cents) : whole * 100 - 1;
  }

  const getJSON = (url) => fetch(url, { headers: { Accept: 'application/json' } }).then((r) => (r.ok ? r.json() : null)).catch(() => null);

  async function init(box) {
    const cfg = JSON.parse(box.dataset.cBundle);
    const format = box.dataset.moneyFormat || '{{amount}}';
    const decimals = /no_decimals/.test(format) ? 0 : 2;
    const product = await getJSON(`${root}products/${cfg.product}.js`);
    if (!product) return;
    const gifts = await Promise.all(cfg.gifts.map((g) => (g.kind === 'shipping' ? null : getJSON(`${root}products/${g.handle}.js`))));
    const hasOptions = !(product.variants.length === 1 && /default title/i.test(product.variants[0].title));
    const firstAvailable = product.variants.find((v) => v.available) || product.variants[0];
    // "Subscribe & save": offered only when the product has a selling plan (made by publish or by a subscription app)
    const plan = cfg.subscription && (product.selling_plan_groups || []).flatMap((g) => g.selling_plans || [])[0];
    const subBox = box.querySelector('[data-sub]');
    if (subBox) subBox.hidden = !plan;
    const subOn = () => Boolean(plan && subBox && subBox.querySelector('input').checked);
    const subFactor = () => (subOn() ? 1 - cfg.subscription.percent / 100 : 1);
    // whole-number currencies show whole prices (179 kr, not 179,10 kr)
    const subRound = (x) => (subOn() && decimals === 0 ? Math.round(x / 100) * 100 : Math.round(x));
    const picks = []; // selected variant per unit, shared across tiers
    const tiers = [...box.querySelectorAll('[data-tier]')];
    const selected = () => Number((box.querySelector('input[name="c-bundle-tier"]:checked') || {}).value || cfg.preselected || 0);
    const variantFor = (i) => picks[i] || firstAvailable;
    const unit = (v, t) => (t.discount.type === 'total' && t.total ? t.total / t.quantity : t.discount.value ? charm(t.discount.type === 'percentage' ? v.price * (1 - t.discount.value / 100) : v.price - t.discount.value * 100, decimals) : v.price);

    function itemRows(tierIndex) {
      const t = cfg.tiers[tierIndex];
      if (!cfg.differentVariants || !hasOptions) return '';
      let html = '';
      for (let i = 0; i < t.quantity; i++) {
        const v = variantFor(i);
        html += `<span class="c-bundle__item">${t.quantity > 1 ? `<span class="c-bundle__num">#${i + 1}</span>` : ''}${product.options
          .map((o, j) => `<select data-unit="${i}" data-option="${j}" aria-label="${o.name}">${o.values.map((val) => `<option${v.options[j] === val ? ' selected' : ''}>${val}</option>`).join('')}</select>`)
          .join('')}</span>`;
      }
      return html;
    }

    function render() {
      const s = selected();
      tiers.forEach((el, i) => {
        const t = cfg.tiers[i];
        const units = Array.from({ length: t.quantity }, (_, k) => variantFor(k));
        const total = subRound(units.reduce((sum, v) => sum + unit(v, t), 0) * subFactor());
        const compare = units.reduce((sum, v) => sum + Math.max(v.compare_at_price || 0, v.price), 0);
        el.querySelector('[data-price]').textContent = money(cfg.perItem ? Math.round(total / t.quantity) : total, format);
        // subtitle: the per-pack price (the tier's own, without the subscription discount) and the saved share
        el.querySelectorAll('[data-unit]').forEach((n) => (n.textContent = money(Math.round(units.reduce((sum, v) => sum + unit(v, t), 0) / t.quantity), format)));
        el.querySelectorAll('[data-pct]').forEach((n) => (n.textContent = compare > total ? `${Math.round((1 - total / compare) * 100)}%` : ''));
        el.querySelector('[data-compare]').textContent = compare > total ? money(cfg.perItem ? Math.round(compare / t.quantity) : compare, format) : '';
        el.classList.toggle('is-selected', i === s);
        const items = el.querySelector('[data-items]');
        items.innerHTML = i === s ? itemRows(i) : '';
      });
      // gifts
      let giftValue = 0;
      box.querySelectorAll('[data-gift]').forEach((el) => {
        const g = cfg.gifts[+el.dataset.gift];
        const p = gifts[+el.dataset.gift];
        const unlocked = cfg.tiers[g.unlockAtTier] && cfg.tiers[s].quantity >= cfg.tiers[g.unlockAtTier].quantity;
        if (el.classList.contains('c-bundle__strip')) return; // the strip under a tier is always shown
        el.classList.toggle('is-locked', !unlocked);
        if (g.kind === 'shipping') return;
        if (!p) return (el.hidden = true);
        const img = el.querySelector('[data-gift-image]');
        if (!img.getAttribute('src') && (p.featured_image || (p.images || [])[0])) img.src = p.featured_image || p.images[0];
        el.querySelector('[data-gift-title]').textContent = p.title;
        const gv = el._variant || p.variants.find((v) => v.available) || p.variants[0];
        el.querySelector('[data-gift-price]').textContent = money(gv.price * g.quantity, format);
        const slot = el.querySelector('[data-gift-variant]');
        if (p.variants.length > 1 && !slot.firstChild) {
          slot.innerHTML = `<select aria-label="${p.options[0]?.name || ''}">${p.variants.map((v) => `<option value="${v.id}">${v.title}</option>`).join('')}</select>`;
          slot.firstChild.onchange = (e) => (el._variant = p.variants.find((v) => String(v.id) === e.target.value));
        }
        if (unlocked) giftValue += gv.price * g.quantity;
      });
      const t = cfg.tiers[s];
      const units = Array.from({ length: t.quantity }, (_, k) => variantFor(k));
      const saved = units.reduce((sum, v) => sum + Math.max(v.compare_at_price || 0, v.price) - unit(v, t) * subFactor(), 0) + giftValue;
      const save = box.querySelector('[data-savings]');
      if (save) {
        save.hidden = saved <= 0;
        save.querySelector('[data-saved]').textContent = money(saved, format);
      }
    }

    box.addEventListener('change', (e) => {
      const sel = e.target.closest('select[data-unit]');
      if (sel) {
        const i = +sel.dataset.unit;
        const chosen = [...box.querySelectorAll(`select[data-unit="${i}"]`)].map((s) => s.value);
        const v = product.variants.find((x) => x.options.every((o, j) => o === chosen[j]));
        if (v) picks[i] = v;
      }
      render();
    });
    render();

    // Take over the product form: add the chosen units and unlocked gifts together.
    const section = box.closest('.shopify-section') || document;
    const forms = [...section.querySelectorAll('form[action*="/cart/add"]')].filter((f) => !f.closest('.c-bundle'));
    const add = async (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      const s = selected();
      const t = cfg.tiers[s];
      const counts = new Map();
      for (let i = 0; i < t.quantity; i++) {
        const v = variantFor(i);
        counts.set(v.id, (counts.get(v.id) || 0) + 1);
      }
      const items = [...counts].map(([id, quantity]) => (subOn() ? { id, quantity, selling_plan: plan.id } : { id, quantity }));
      let freeShipping = false;
      box.querySelectorAll('[data-gift]').forEach((el) => {
        const g = cfg.gifts[+el.dataset.gift];
        const p = gifts[+el.dataset.gift];
        if (g.kind === 'shipping') return;
        const unlocked = p && cfg.tiers[g.unlockAtTier] && t.quantity >= cfg.tiers[g.unlockAtTier].quantity;
        if (unlocked && /^shipping-protection/.test(g.handle || '')) freeShipping = true;
        // hidden line properties record what the gift was given for, so it can be taken back (syncGifts)
        if (unlocked) items.push({ id: (el._variant || p.variants.find((v) => v.available) || p.variants[0]).id, quantity: g.quantity,
          properties: { _gift_for: cfg.product, _gift_min: String(cfg.tiers[g.unlockAtTier].quantity) } });
      });
      // the shipping protection is ticked by default: it goes in with the product unless the shopper turned it off,
      // it is already in the cart, or this tier comes with the free one (theme-fixes.js keeps it right afterwards)
      const protection = document.querySelector('cart-drawer-upsell[data-handle="shipping-protection"]');
      let optedOut = false;
      try { optedOut = localStorage.getItem('c_ship_optout') === '1'; } catch (err) {}
      if (protection && protection.dataset.id && protection.dataset.selected !== 'true' && !optedOut && !freeShipping) {
        items.push({ id: Number(protection.dataset.id), quantity: 1 });
      }
      e.stopPropagation();
      // open the drawer on the tap, with a spinner, instead of after the cart has answered (that took seconds on a phone)
      const drawerNow = document.querySelector('cart-drawer');
      if (drawerNow) {
        drawerNow.classList.add('is-loading');
        if (!drawerNow.classList.contains('active')) { try { typeof drawerNow.open === 'function' ? drawerNow.open() : drawerNow.classList.add('active'); } catch (err) {} }
      }
      const button = e.target.closest('form')?.querySelector('[type="submit"], [name="add"]') || e.target.closest('button');
      button?.setAttribute('aria-busy', 'true');
      try {
        // sections to re-render: the cart sections known at build time, or (Horizon-style themes)
        // the section that holds the cart drawer, named on the page itself
        const hosted = [...document.querySelectorAll('cart-items-component[data-section-id]')].map((el) => el.dataset.sectionId);
        const sections = hosted.length ? [...new Set(hosted)] : cfg.sections;
        const res = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items, sections: sections.join(','), sections_url: location.pathname }),
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart');
        await refreshCart(data, items.reduce((n, i) => n + i.quantity, 0));
      } catch (err) {
        console.error('[bundle]', err);
        location.href = `${root}cart`;
      } finally {
        document.querySelector('cart-drawer')?.classList.remove('is-loading');
        button?.removeAttribute('aria-busy');
      }
    };
    // On window, so it runs before themes that handle submit with one capturing listener on document
    // (Horizon's declarative on:submit); otherwise the theme would add the product a second time.
    window.addEventListener('submit', (e) => (forms.includes(e.target) ? add(e) : null), true);
    // custom-coded pages: their buy buttons, marked by the capture
    document.addEventListener('click', (e) => (e.target.closest('[data-c-add]') ? add(e) : null), true);
    section.querySelectorAll('button[name="add"]').forEach((b) => b.addEventListener('click', (e) => (b.form ? null : add(e)), true));
  }

  // Show the new cart the way the theme does: its drawer's own update function if it has one,
  // otherwise swap in the re-rendered sections, then open the drawer (or go to /cart).
  async function refreshCart(data, added) {
    // Horizon-style themes: their components re-render and open the drawer on the theme's own cart event.
    if (document.querySelector('cart-items-component[data-section-id]')) {
      // No extra /cart.js round trip and no delay: the add response already carries the re-rendered
      // drawer, so it opens as soon as Shopify answers.
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: null, sourceId: 'c-bundle', data: { source: 'c-bundle', itemCount: added || 0, sections: data.sections || {} } },
      }));
      const horizonDrawer = document.querySelector('cart-drawer-component');
      if (horizonDrawer && !horizonDrawer.querySelector('dialog[open]')) {
        if (typeof horizonDrawer.showDialog === 'function') horizonDrawer.showDialog();
        else if (typeof horizonDrawer.open === 'function') horizonDrawer.open();
      }
      return;
    }
    const drawer = document.querySelector('cart-drawer, cart-notification');
    if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
      try {
        drawer.renderContents({ ...data, id: (data.items || [])[0]?.id, sections: data.sections });
        drawer.classList.remove('is-empty');
        // the theme redraws the lines and totals but leaves the toggles as they were: set them from the re-rendered drawer
        try {
          const html = Object.values(data.sections).find((h) => h && String(h).includes('cart-drawer-upsell'));
          if (html) {
            new DOMParser().parseFromString(html, 'text/html').querySelectorAll('cart-drawer-upsell[data-handle]').forEach((fresh) => {
              document.querySelectorAll('cart-drawer-upsell').forEach((el) => {
                if (el.dataset.handle === fresh.dataset.handle) el.dataset.selected = fresh.dataset.selected;
              });
            });
          }
        } catch (e) {}
        return;
      } catch (e) {
        console.warn('[bundle] drawer update failed', e);
      }
    }
    const parse = (html) => new DOMParser().parseFromString(html, 'text/html');
    let swapped = false;
    for (const [id, html] of Object.entries(data.sections || {})) {
      if (!html) continue;
      const doc = parse(html);
      const byTag = document.querySelector(id);
      const fresh = doc.querySelector(id);
      if (byTag && fresh) {
        byTag.innerHTML = fresh.innerHTML;
        [...fresh.attributes].forEach((a) => byTag.setAttribute(a.name, a.value));
        swapped = true;
        continue;
      }
      const target = document.getElementById(id) || document.getElementById(`shopify-section-${id}`);
      const src = doc.getElementById(`shopify-section-${id}`) || doc.body;
      if (target && src) {
        target.innerHTML = src.innerHTML;
        swapped = true;
      }
    }
    if (drawer && swapped) {
      drawer.classList.remove('is-empty');
      if (typeof drawer.open === 'function') drawer.open();
      else drawer.classList.add('active');
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    } else {
      location.href = `${root}cart`;
    }
  }

  // A free gift stays free only while the cart still holds the quantity it was given for. When the
  // shopper lowers the quantity or removes the product, the gift lines go too (otherwise Shopify
  // would charge full price for them). Runs on every page with the theme's cart event.
  let syncing = false;
  async function syncGifts() {
    if (syncing) return;
    syncing = true;
    try {
      const cart = await getJSON(`${root}cart.js`);
      if (!cart || !cart.items) return;
      const bought = {};
      cart.items.forEach((i) => {
        if (!(i.properties && i.properties._gift_for)) bought[i.handle] = (bought[i.handle] || 0) + i.quantity;
      });
      const stale = cart.items.filter((i) => i.properties && i.properties._gift_for && (bought[i.properties._gift_for] || 0) < Number(i.properties._gift_min || 0));
      if (!stale.length) return;
      const updates = {};
      stale.forEach((i) => (updates[i.key] = 0));
      const hosted = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map((el) => el.dataset.sectionId))];
      const res = await fetch(`${root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates, sections: hosted.join(','), sections_url: location.pathname }),
      });
      const data = await res.json();
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: null, sourceId: 'c-bundle', data: { source: 'c-bundle', itemCount: 0, sections: data.sections || {} } },
      }));
    } catch (err) {
      console.warn('[bundle] gift sync failed', err);
    } finally {
      syncing = false;
    }
  }
  document.addEventListener('cart:update', (e) => {
    if (e.detail && e.detail.data && e.detail.data.source === 'c-bundle') return;
    setTimeout(syncGifts, 60);
  });

  const start = () => document.querySelectorAll('.c-bundle[data-c-bundle]').forEach((b) => init(b));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
